export const GET_CLINIC_INFORMATION_REQUEST = "GET_CLINIC_INFORMATION_REQUEST";
export type GET_CLINIC_INFORMATION_REQUEST = typeof GET_CLINIC_INFORMATION_REQUEST;

export const GET_PATIENT_INFO = "GET_PATIENT_INFO";
export type GET_PATIENT_INFO = typeof GET_PATIENT_INFO;

export const PUT_PATIENT_INFO = "PUT_PATIENT_INFO";
export type PUT_PATIENT_INFO = typeof PUT_PATIENT_INFO;

export const POST_PATIENT_INFO = "POST_PATIENT_INFO";
export type POST_PATIENT_INFO = typeof POST_PATIENT_INFO;

export const POST_LOGIN_INFORMATION = "POST_LOGIN_INFORMATION";
export type POST_LOGIN_INFORMATION = typeof POST_LOGIN_INFORMATION;

export const POST_SURVEY_RESULT = "POST_SURVEY_RESULT";
export type POST_SURVEY_RESULT = typeof POST_SURVEY_RESULT;


// WEBPACK FOOTER //
// ./src/sagas/RequestSagas/constant.ts